<p-dialog
  header="{{ folderDialogContent.head | translate }}"
  [(visible)]="folderDialogContent.showFolderDialog"
  [style]="{ width: '34vw' }"
  [modal]="true"
  styleClass="{{ folderDialogContent.styleClass }}"
  [draggable]="false"
>
  <div class="w-full mb-2">
    <div class="mb-3" [formGroup]="newFolderForm">
      <ng-container *ngFor="let field of folderDialogContent.formField">
        <div class="w-100 mb-2">
          <label>
            {{ field.label | translate }}
            <span class="mandatory" *ngIf="field.isRequired">*</span></label
          >
          <input
            *ngIf="field.type === 'text'"
            class="form-control"
            type="text"
            [placeholder]="field.placeholder | translate"
            [formControlName]="field.model"
          />

          <app-form-error
            type="2"
            [formControlName]="field.model"
            [errors]="field['errors']"
          >
          </app-form-error>
        </div>
      </ng-container>
    </div>

    <div class="folder-location">
      <p><span>{{ 'SHARED.CURRENT_LOCATION' | translate }}</span></p>
      <p class="capitalize">{{ folderDialogContent.folderLocation | translate }}</p>
    </div>
  </div>
  <ng-template pTemplate="footer">
    <div class="flex justify-end gap-3">
      <app-button-secondary
        (actionButtonCall)="folderFormAction(false)"
        buttonCaption="{{ folderDialogContent.btnCancel | translate }}"
        buttonClassName="xs-medium"
      ></app-button-secondary>
      <app-button-primary
        buttonCaption="{{ folderDialogContent.btnProceed | translate }}"
        (actionButtonCall)="folderFormAction(true)"
        buttonClassName="xs-medium"
      ></app-button-primary>
    </div>
  </ng-template>
</p-dialog>
